import { useQuery } from "@tanstack/react-query";
import { designersApi } from "../api/designersApi";
import { designersKeys } from "../api/designersKeys";

export const useDesigner = (documentId, params) =>
  useQuery({
    queryKey: designersKeys.detail(documentId),
    queryFn: () => designersApi.get(documentId, params),
    enabled: Boolean(documentId),
  });
